import { testIsUndefined } from '../test-and-assert/test-base';
import { assertIsFunction, assertIsNonEmptyString, assertIsObject } from '../test-and-assert/assert-base';

/**
 * @param {String} locale
 * @param {Date} date
 * @param {Object} [options]
 * @param {Boolean} [isFromEurope=false]
 *
 * @returns {String}
 */
function getLocalizedDateString(locale, date, options, isFromEurope) {
    assertIsNonEmptyString(locale);
    assertIsObject(date);
    assertIsFunction(date.toLocaleDateString);

    if (testIsUndefined(options)) {
        options = {};
    }

    if (testIsUndefined(isFromEurope)) {
        isFromEurope = false;
    }

    if (locale === 'en' && isFromEurope) {
        locale = 'en-GB';
    }

    return date.toLocaleDateString(locale, options);
}

export { getLocalizedDateString };
